var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"t1content"}},[_c('a-layout-content',[_c('T1Breadcrumbs',{staticClass:"mb-16",attrs:{"homeLink":true,"items":_vm.getBreadcrumbs()}}),_c('T1RezerwacjaError')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }